(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rss-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {

    function parseCounterValue(rawValue) {
      var raw = String(rawValue || '').trim();
      var match = raw.match(/-?[\d,.]+/);
      if (!match) return null;

      var numberText = match[0];
      var target = Number(numberText.replace(/,/g, ''));
      if (!Number.isFinite(target)) return null;

      return {
        target: target,
        prefix: raw.slice(0, match.index),
        suffix: raw.slice(match.index + numberText.length),
        decimals: numberText.indexOf('.') > -1 ? numberText.split('.')[1].length : 0,
        useGrouping: numberText.indexOf(',') > -1
      };
    }

    function formatCounterValue(value, config) {
      return config.prefix + value.toLocaleString('en-US', {
        minimumFractionDigits: config.decimals,
        maximumFractionDigits: config.decimals,
        useGrouping: config.useGrouping
      }) + config.suffix;
    }

    function initProofCounters(section) {
      var stats = section.querySelector('.rss-proof-stats');
      var counters = Array.prototype.slice.call(section.querySelectorAll('[data-count-up]'));
      if (!stats || !counters.length || stats.dataset.countReady === 'true') return;
      stats.dataset.countReady = 'true';

      function resetToZero() {
        counters.forEach(function (counter) {
          var config = parseCounterValue(counter.dataset.countValue);
          if (!config) return;
          counter.textContent = config.suffix === '%' ? '0%' : '0';
        });
      }

      function completeImmediately() {
        counters.forEach(function (counter) {
          var config = parseCounterValue(counter.dataset.countValue);
          if (config) counter.textContent = formatCounterValue(config.target, config);
        });
      }

      function runCounters() {
        if (stats.dataset.countStarted === 'true') return;
        stats.dataset.countStarted = 'true';
        var duration = 3000;
        var startTime = null;

        function tick(timestamp) {
          if (startTime === null) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);

          counters.forEach(function (counter) {
            var config = parseCounterValue(counter.dataset.countValue);
            if (!config) return;
            var current = config.target * eased;
            current = config.decimals > 0
              ? Number(current.toFixed(config.decimals))
              : Math.round(current);
            if (progress < 1 && config.suffix === '+') {
              counter.textContent = config.prefix + current.toLocaleString('en-US', {
                minimumFractionDigits: config.decimals,
                maximumFractionDigits: config.decimals,
                useGrouping: config.useGrouping
              });
            } else {
              counter.textContent = formatCounterValue(current, config);
            }
          });

          if (progress < 1) {
            window.requestAnimationFrame(tick);
          } else {
            completeImmediately();
          }
        }

        window.requestAnimationFrame(tick);
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        completeImmediately();
        return;
      }

      resetToZero();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.25) return;
            observer.disconnect();
            runCounters();
          });
        }, {
          threshold: 0.25,
          rootMargin: '0px 0px -5% 0px'
        });
        observer.observe(stats);
      } else {
        var checkStatsVisibility = function () {
          var rect = stats.getBoundingClientRect();
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
          var requiredHeight = Math.min(stats.offsetHeight * 0.25, viewportHeight * 0.25);

          if (visibleHeight < requiredHeight) return;

          window.removeEventListener('scroll', checkStatsVisibility);
          window.removeEventListener('resize', checkStatsVisibility);
          runCounters();
        };

        window.addEventListener('scroll', checkStatsVisibility, { passive: true });
        window.addEventListener('resize', checkStatsVisibility, { passive: true });
      }
    }

    function initReviewSection(section) {
      if (!section) return;
      initProofCounters(section);
      if (section.dataset.proofReady === 'true') return;
      section.dataset.proofReady = 'true';

      var grid = section.querySelector('[data-review-grid]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-review-card]'));
      var prev = section.querySelector('[data-page-prev]');
      var next = section.querySelector('[data-page-next]');
      var pageNumbers = section.querySelector('[data-page-numbers]');
      var pagination = section.querySelector('[data-pagination]');
      var pageSize = parseInt(section.dataset.pageSize || '6', 10);
      var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      var numbersPerGroup = 3;
      var currentPage = 1;
      var renderedGroupStart = null;

      /* Show only the cards of one page (no scrolling side effects) */
      function showCardsOfPage(page) {
        var start = (page - 1) * pageSize;
        var end = start + pageSize;
        cards.forEach(function (card, index) {
          card.hidden = index < start || index >= end;
        });
      }

      /* Lock the grid to the tallest page height at the current screen width,
         so switching pages never changes the section height (desktop + mobile). */
      function lockGridHeight() {
        if (!grid || totalPages < 2) return;
        var savedScrollLeft = grid.scrollLeft;
        grid.style.minHeight = '';
        var tallest = 0;
        for (var page = 1; page <= totalPages; page += 1) {
          showCardsOfPage(page);
          tallest = Math.max(tallest, grid.getBoundingClientRect().height);
        }
        showCardsOfPage(currentPage);
        grid.style.minHeight = Math.ceil(tallest) + 'px';
        grid.scrollLeft = savedScrollLeft;
      }

      /* Page numbers move in fixed groups: 1 2 3 → 4 5 6 → ...
         Clicking 2 or 3 only changes the active number; the group changes
         only when the arrows move past the edge of the current group. */
      function renderPageNumbers() {
        if (!pageNumbers) return;
        var groupStart = Math.floor((currentPage - 1) / numbersPerGroup) * numbersPerGroup + 1;
        var groupEnd = Math.min(totalPages, groupStart + numbersPerGroup - 1);

        if (groupStart !== renderedGroupStart) {
          renderedGroupStart = groupStart;
          pageNumbers.innerHTML = '';
          for (var pageNumber = groupStart; pageNumber <= groupEnd; pageNumber += 1) {
            var pageButton = document.createElement('button');
            pageButton.type = 'button';
            pageButton.className = 'rss-proof-pagination__number';
            pageButton.textContent = pageNumber;
            pageButton.setAttribute('aria-label', 'Show reviews page ' + pageNumber);
            pageButton.setAttribute('data-page-number', pageNumber);
            pageNumbers.appendChild(pageButton);
          }
        }

        Array.prototype.forEach.call(pageNumbers.querySelectorAll('[data-page-number]'), function (button) {
          var isActive = parseInt(button.getAttribute('data-page-number'), 10) === currentPage;
          button.classList.toggle('is-active', isActive);
          if (isActive) {
            button.setAttribute('aria-current', 'page');
          } else {
            button.removeAttribute('aria-current');
          }
        });
      }

      function instantScrollBy(offset) {
        var root = document.documentElement;
        var previousBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        window.scrollTo(window.pageXOffset, window.pageYOffset + offset);
        root.style.scrollBehavior = previousBehavior;
      }

      /* keepPosition: the customer's viewport stays exactly where it was */
      function renderPage(page, keepPosition) {
        var anchorTop = keepPosition && pagination ? pagination.getBoundingClientRect().top : null;
        var focusedArrow = document.activeElement === prev || document.activeElement === next ? document.activeElement : null;

        currentPage = Math.max(1, Math.min(totalPages, page));
        showCardsOfPage(currentPage);

        /* Mobile carousel: return to the first card of the new page */
        if (grid) grid.scrollLeft = 0;

        renderPageNumbers();

        if (prev) prev.disabled = currentPage === 1;
        if (next) next.disabled = currentPage === totalPages;

        if (anchorTop !== null) {
          /* Safety net in case anything else changed height */
          var shift = pagination.getBoundingClientRect().top - anchorTop;
          if (Math.abs(shift) > 0.5) instantScrollBy(shift);

          var focusTarget = focusedArrow && !focusedArrow.disabled
            ? focusedArrow
            : pageNumbers && pageNumbers.querySelector('[aria-current="page"]');
          if (focusTarget && focusTarget !== document.activeElement && focusTarget.focus) {
            try { focusTarget.focus({ preventScroll: true }); } catch (error) {}
          }
        }
      }

      if (pageNumbers) {
        pageNumbers.addEventListener('click', function (event) {
          var button = event.target.closest('[data-page-number]');
          if (!button) return;
          var target = parseInt(button.getAttribute('data-page-number'), 10);
          if (target === currentPage) return;
          renderPage(target, true);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          renderPage(currentPage - 1, true);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          renderPage(currentPage + 1, true);
        });
      }

      renderPage(1, false);
      lockGridHeight();

      /* Re-measure when layout can change: resize, fonts, full load */
      var resizeTimer = null;
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return; /* ignore mobile URL-bar height changes */
        lastWidth = window.innerWidth;
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(lockGridHeight, 150);
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(lockGridHeight);
      }
      window.addEventListener('load', lockGridHeight);
    }

    function initAllReviewSections(root) {
      if (root.matches && root.matches('[data-rss-proof]')) {
        initReviewSection(root);
      }

      root.querySelectorAll('[data-rss-proof]').forEach(function (section) {
        initReviewSection(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllReviewSections(document);
      });
    } else {
      initAllReviewSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllReviewSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
